<template>
  <v-container>
    <v-col cols="12" md="6" class="mx-auto">
      <v-text-field
        outlined
        :append-icon="query.search ? 'mdi-close' : ''"
        v-model="query.search"
        :placeholder="$t('button.search')"
        prepend-inner-icon="mdi-magnify"
        hide-details
        @keypress.enter="handleFilter"
        @click:append="clearFilter"
      ></v-text-field>

      <small v-if="hint" class="mb-3 mx-2 mt-1 d-block">
        Hint: {{ hint }}
      </small>
    </v-col>
    <v-toolbar flat class="main-header mb-6">
      <v-toolbar-title class="main-header__title">
        <h1>SCM Employees</h1>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items
        v-if="permissions.includes('store_api_admin-panel_scm_camps')"
        class="main-header__contents"
      >
        <v-btn
          class="my-auto mx-1 radius-12"
          color="success"
          to="/scm/employees/create"
        >
          <v-icon>mdi-plus-circle</v-icon>
          <span class="mx-2">Add Employee</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <hr class="mb-6" />
    <v-data-table
      :headers="headers"
      :loading="loadingDataTable"
      :items="employees"
      :mobile-breakpoint="zero"
      :items-per-page="200"
      hide-default-footer
      class="table teams"
    >
      <template v-slot:item="{ item, index }">
        <tr class="table__row">
          <td class="table__cell name text-center">
            {{ item ? item.name : "---" }}
          </td>
          <td class="table__cell text-center">
            {{ item ? item.email : "---" }}
          </td>
          <td class="table__cell name text-center">
            <v-chip v-if="item.is_active" color="success"> Yes </v-chip>
            <v-chip v-else color="error"> No </v-chip>
          </td>

          <td class="table__cell text-center">
            <router-link
              :to="`/scm/employees/edit/${item.id}`"
              class="hovering mr-1 edit"
              v-if="
                permissions.includes('update_api_admin-panel_scm_camps_{camp}')
              "
            >
              <v-icon small>mdi-pencil</v-icon><br />
              Edit
            </router-link>
            <span
              v-if="
                permissions.includes('destroy_api_admin-panel_scm_camps_{camp}')
              "
              @click="handleDelete(item, index)"
              class="hovering delete"
            >
              <v-icon small>mdi-delete</v-icon><br />
              Delete
            </span>
            <span v-else>---</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      employees: [],
      loadingDataTable: false,
      hint: this.$t("search_by_name_or_email"),
      query: {
        search: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      permissions: "permissions",
    }),
  },
  created() {
    this.createTableHeaders();
  },
  methods: {
    clearFilter() {
      const query = { ...this.$route.query };
      this.$delete(query, "search");
      this.$router.push({ query });
      this.query.search = "";
    },
    handleFilter() {
      if (this.query["search"] !== "") {
        this.$router.push({ query: { ...this.$route.query, ...this.query } });
      }
    },
    indexcashiers(query) {
      this.loadingDataTable = true;
      IndexData({ reqName: `scm/employees`, query })
        .then((res) => {
          const { data } = res.data;
          this.employees = data;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = ["Name", "Email", "Is Active ?", "Actions"];
      this.headers = TableHeaders(headersList);
    },
    handleEdit() {},
    handleDelete({ id }, index) {
      this.popUp().then((value) => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/scm/employees`,
            id: id,
          })
            .then(() => {
              this.employees.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    },
  },
  watch: {
    $route: {
      handler({ query }) {
        if (query.search) {
          this.query.search = query.search;
        }
        this.indexcashiers(query);
      },
      immediate: true,
    },
  },
};
</script>
